import { render, staticRenderFns } from "./AdminUploadWill.vue?vue&type=template&id=7a52bedf"
import script from "./AdminUploadWill.vue?vue&type=script&lang=js"
export * from "./AdminUploadWill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports